import { render, staticRenderFns } from "./table7.vue?vue&type=template&id=64bf683a&scoped=true&"
import script from "./table7.vue?vue&type=script&lang=js&"
export * from "./table7.vue?vue&type=script&lang=js&"
import style0 from "./table7.vue?vue&type=style&index=0&lang=css&"
import style1 from "./table7.vue?vue&type=style&index=1&id=64bf683a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf683a",
  null
  
)

export default component.exports